import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import ContactPanel from './ContactPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const extrastyles = (theme:Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
});
const styles = extendedstyles(extrastyles);

class ContactCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("ContactCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,setItem} = this.props;
    const {photo,idcard} = data.start;
    return (
      <BaseCard
        cardid={'CONTACT'}
        cardname={'Contact'}
        cardtitle={'Contact Information'}
        instruction={'Provide contact information of customer'}
        step={4}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <ContactPanel 
          data={extraProps.data}
          record={record} 
          extras={extras}
          photo={photo} 
          idcard={idcard}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

ContactCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContactCard);
